import { IconType } from 'components/Icon';
import ActionButton from 'components/Widget/ActionButton';
import { useSelector } from 'react-redux';
import { selectGithubConnected } from 'redux/db/reducers';
import { RootReducer } from 'redux/reducers';
import { openGithubAuthPopup } from 'utils';

interface Props {
	label: string;
}

const ConnectGithubAction = ({ label }: Props) => {
	const githubConnected = useSelector((r: RootReducer) => selectGithubConnected(r.db));

	const onClick = async () => {
		await openGithubAuthPopup();
	};

	return (
		<ActionButton
			icon={githubConnected ? IconType.CONNECTED : IconType.GITHUB}
			label={githubConnected ? 'Connected to GitHub' : label}
			onClick={onClick}
		/>
	);
};

export default ConnectGithubAction;
